<template>
  <layout :title-text="title">
    <div slot="content" class="promotion-container">
      <div class="tabs">
        <div class="tabs-title">
            <ul>
                <li :class="{'show-li': active === 1}" @click="tabsClick(1)">北部赛区</li>
                <li :class="{'show-li': active === 2}" @click="tabsClick(2)">东部赛区</li>
                <li :class="{'show-li': active === 3}" @click="tabsClick(3)">中西部赛区</li>
                <li :class="{'show-li': active === 4}" @click="tabsClick(4)">南部赛区</li>
            </ul>
        </div>
        <div class="tabs-text">
            <div class="text" :class="{'show' : active === 1}">
              <div class="table-content">
                <q-table
                  :data="northList.slice((currentPage1-1)*pageSize,currentPage1*pageSize)"
                  :header-cell-style="{ 'text-align': 'center', 'border-color': '#465ECC'}"
                  :cell-style="{ color: '#5891FA', 'font-size': '16px', 'text-align': 'center', 'border-color': '#465ECC'}"
                >
                  <q-table-column prop="id" label="战队名称">
                  </q-table-column>
                  <q-table-column prop="name" label="战队所属学校">
                  </q-table-column>
                </q-table>
                <q-pagination
                  background
                  layout="pager"
                  :current-page.sync="currentPage1"
                  :page-size="pageSize"
                  :total="total">
                </q-pagination>
              </div>
            </div>
            <div class="text" :class="{'show' : active === 2}">
              <div class="table-content">
                <q-table
                  :data="eastList.slice((currentPage2-1)*pageSize,currentPage2*pageSize)"
                  :header-cell-style="{ 'text-align': 'center', 'border-color': '#465ECC'}"
                  :cell-style="{ color: '#5891FA', 'font-size': '16px', 'text-align': 'center', 'border-color': '#465ECC'}"
                >
                  <q-table-column prop="id" label="战队名称">
                  </q-table-column>
                  <q-table-column prop="name" label="战队所属学校">
                  </q-table-column>
                </q-table>
                <q-pagination
                  background
                  layout="pager"
                  :current-page.sync="currentPage2"
                  :page-size="pageSize"
                  :total="total">
                </q-pagination>
              </div>
            </div>
            <div class="text" :class="{'show' : active === 3}">
              <div class="table-content">
                <q-table
                  :data="midWestList.slice((currentPage3-1)*pageSize,currentPage3*pageSize)"
                  :header-cell-style="{ 'text-align': 'center', 'border-color': '#465ECC'}"
                  :cell-style="{ color: '#5891FA', 'font-size': '16px', 'text-align': 'center', 'border-color': '#465ECC'}"
                >
                  <q-table-column prop="id" label="战队名称">
                  </q-table-column>
                  <q-table-column prop="name" label="战队所属学校">
                  </q-table-column>
                </q-table>
                <q-pagination
                  background
                  layout="pager"
                  :current-page.sync="currentPage3"
                  :page-size="pageSize"
                  :total="total">
                </q-pagination>
              </div>
            </div>
            <div class="text" :class="{'show' : active === 4}">
              <div class="table-content">
                <q-table
                  :data="southList.slice((currentPage4-1)*pageSize,currentPage4*pageSize)"
                  :header-cell-style="{ 'text-align': 'center', 'border-color': '#465ECC'}"
                  :cell-style="{ color: '#5891FA', 'font-size': '16px', 'text-align': 'center', 'border-color': '#465ECC'}"
                >
                  <q-table-column prop="id" label="战队名称">
                  </q-table-column>
                  <q-table-column prop="name" label="战队所属学校">
                  </q-table-column>
                </q-table>
              </div>
              <q-pagination
                  background
                  layout="pager"
                  :current-page.sync="currentPage4"
                  :page-size="pageSize"
                  :total="total">
                </q-pagination>
            </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'
export default {
  components: {
    Layout
  },
  data () {
    return {
      title: '晋级名单',
      active: 1,
      northList: [
        { id: 'ylly', name: '北京邮电大学' },
        { id: '于波永远滴神', name: '中国人民警察大学' },
        { id: 'OFO', name: '北京邮电大学' },
        { id: '天璇Merak', name: '北京邮电大学' },
        { id: '随便起个名', name: '山东警察学院' },
        { id: 'neuqro', name: '东北大学秦皇岛分校' },
        { id: 'KKCU', name: '北京邮电大学' },
        { id: 'or4nge', name: '北京航空航天大学' },
        { id: 'Not_that_Good', name: '北京邮电大学' },
        { id: '驴肉火烧', name: '中国人民警察大学' },
        { id: '漠南·晨曦', name: '内蒙古警察职业学院' },
        { id: '漠南·朝夕', name: '内蒙古警察职业学院' },
        { id: '漠南探幽', name: '内蒙古警察职业学院' },
        { id: 'AMI', name: '北京邮电大学' },
        { id: '啥也不队', name: '北京邮电大学' },
        { id: 'l3ft_edg3', name: '北京航空航天大学' },
        { id: 'flybug', name: '北京邮电大学' },
        { id: 'sakura', name: '北京邮电大学' },
        { id: '阿巴阿巴', name: '北京邮电大学' },
        { id: '啥都打打-3', name: '哈尔滨工业大学（威海）' },
        { id: 'Sailing', name: '黑龙江公安警官职业学院' },
        { id: '圣地亚哥皮蛋', name: '山东警察学院' },
        { id: '魔法少女继续摸', name: '吉林工程技术师范学院,江苏科技大学' },
        { id: '卡布奇诺', name: '山东警察学院' },
        { id: '芜湖起飞', name: '山东警察学院' },
        { id: '似水流年', name: '山东警察学院' },
        { id: 'Ir0ny', name: '山东警察学院' },
        { id: 'Ganten', name: '北京邮电大学' },
        { id: 'TeamWeCylors', name: '辽宁警察学院' },
        { id: '糖醋排骨糯米糍', name: '济南工程职业技术学院,太原理工大学' },
        { id: 'Ginkgo', name: '防灾科技学院' },
        { id: '天命', name: '防灾科技学院,徐州工程学院,许昌职业技术学院' },
        { id: 'Besti', name: '北京电子科技学院' },
        { id: 'Birkenwald', name: '哈尔滨理工大学' },
        { id: '3FW', name: '防灾科技学院' },
        { id: 'Chickens', name: '辽宁警察学院' },
        { id: 'She11', name: '山东建筑大学' },
        { id: 'N3X', name: '东北大学' },
        { id: 'PolarNight', name: '吉林警察学院' },
        { id: '打五把AWD', name: '山东建筑大学' },
        { id: 'Never-Stop-Moyuing', name: '中国科学院大学,合肥工业大学,中国科学技术大学' },
        { id: 'PolarShine', name: '吉林警察学院' },
        { id: '干炒牛河', name: '中国人民公安大学' },
        { id: 'PolarDay', name: '吉林警察学院' },
        { id: 'PolarStar', name: '吉林警察学院' },
        { id: '北极星', name: '黑龙江公安警官职业学院' },
        { id: 'Buming', name: '黑龙江公安警官职业学院' },
        { id: '菠萝包内冇菠萝', name: '中国人民警察大学' },
        { id: 'Wake', name: '中央司法警官学院' },
        { id: '虎皮凤爪', name: '中国人民公安大学' }
      ],
      eastList: [
        { id: '红烧划水', name: '江苏警官学院' },
        { id: '肥宅快乐队', name: '南京航空航天大学' },
        { id: 'T0rchWOod_2', name: '江西警察学院' },
        { id: 'nepnep', name: '中国人民公安大学,江苏科技大学,南京邮电大学' },
        { id: 'Zodiac', name: '浙江警察学院' },
        { id: 'mini-Venom', name: '同济大学,北京邮电大学,西安工业大学' },
        { id: 'Uni', name: '江苏警官学院' },
        { id: '歪比巴卜', name: '江苏警官学院' },
        { id: '歪比歪比', name: '江苏警官学院' },
        { id: '水是一个动词', name: '江苏警官学院' },
        { id: '绝望的肉', name: '杭州电子科技大学' },
        { id: 'Ph0t1n1a', name: '上海交通大学' },
        { id: 'JustLook', name: '东南大学' },
        { id: 'An4t0le', name: '南京邮电大学' },
        { id: 'W_B', name: '上海公安学院' },
        { id: 'DoK0wn', name: '浙江师范大学行知学院' },
        { id: 'fw竟是我', name: '杭州电子科技大学信息工程学院,杭州师范大学' },
        { id: 'T0rchWOod_4', name: '江西警察学院' },
        { id: 'T0rchWOod_5', name: '江西警察学院' },
        { id: 'T0rchWOod_10', name: '江西警察学院' },
        { id: 'T0rchWOod_3', name: '江西警察学院' },
        { id: 'T0rchWOod_8', name: '江西警察学院' },
        { id: 'T0rchWOod_12', name: '江西警察学院' },
        { id: 'T0rchWOod_9', name: '江西警察学院' },
        { id: 'T0rchWOod_1', name: '江西警察学院' },
        { id: 'NoneSecc', name: '江苏海洋大学' },
        { id: 'T0rchWOod_11', name: '江西警察学院' },
        { id: 'T0rchWOod_7', name: '江西警察学院' },
        { id: 'ms17_010', name: '湖南警察学院' },
        { id: 'HatTrick2021', name: '江苏海洋大学' },
        { id: '最后的光', name: '湖南警察学院' },
        { id: '随便起个名字好啦', name: '安徽工业经济职业技术学院' },
        { id: '移动画报', name: '安徽公安职业学院' },
        { id: '稻草人安全团队', name: '国际关系学院,中北大学' },
        { id: 'signal', name: '上海公安学院' },
        { id: '惊奇脆饼', name: '上海公安学院' },
        { id: '深邃黑暗幻想', name: '湖南警察学院' },
        { id: '小分队', name: '上海公安学院' },
        { id: '天下第一', name: '湖南警察学院' },
        { id: 'Asuri_2021', name: '南京航空航天大学' },
        { id: 'Injection', name: '湖南警察学院' },
        { id: 'R00k1e', name: '苏州信息职业技术学院' },
        { id: 'Hello_World', name: '江苏海洋大学' },
        { id: 'NullByte', name: '江西警察学院' },
        { id: 'Forestwo1f_6', name: '南京森林警察学院' },
        { id: 'Forestwo1f_9', name: '南京森林警察学院' },
        { id: '狸猫换太子', name: '湖南警察学院' },
        { id: 'Forestwo1f_5', name: '南京森林警察学院' },
        { id: 'K_A', name: '上海公安学院' },
        { id: 'Forestwo1f_1', name: '南京森林警察学院' }
      ],
      midWestList: [
        { id: 'C4M31', name: '兰州大学' },
        { id: 'Syclover', name: '成都信息工程大学' },
        { id: 'p0rnhublover', name: '成都信息工程大学' },
        { id: 'sycllover', name: '成都信息工程大学' },
        { id: '曾某人队', name: '成都信息工程大学' },
        { id: 'S1gMa', name: '新疆警察学院' },
        { id: '北极星01', name: '湖南科技学院,武汉大学,南京邮电大学' },
        { id: '服来鸽提交处', name: '河南警察学院' },
        { id: '7', name: '西安电子科技大学' },
        { id: '大脸猫', name: '新疆警察学院' },
        { id: '四川泡菜', name: '四川警察学院' },
        { id: 'gou8er', name: '新疆警察学院' },
        { id: '推诚尚勇', name: '甘肃警察职业学院' },
        { id: 'hhhhh', name: '成都信息工程大学' },
        { id: 'Nothing', name: '成都信息工程大学' },
        { id: 'bhc还不错', name: '成都信息工程大学' },
        { id: '青云', name: '陕西警官职业学院' },
        { id: 'NFYB', name: '山西警察学院' },
        { id: '晓安全', name: '山西警察学院' },
        { id: '2dm1n', name: '山西警察学院' },
        { id: '摸鱼组合', name: '山西警察学院' },
        { id: '不会签到题', name: '陕西警官职业学院' },
        { id: 'BELIEVERS', name: '陕西警官职业学院' },
        { id: 'Dormant', name: '陕西警官职业学院' },
        { id: '768387', name: '陕西警官职业学院' },
        { id: '夜色凉凉', name: '河南大学' },
        { id: '专业团队', name: '山西警察学院' },
        { id: '南风小巷', name: '山西警察学院' },
        { id: '胜羽队', name: '山西警察学院' },
        { id: 'SH1FT', name: '重庆警察学院' },
        { id: 'TAB1', name: '重庆警察学院' },
        { id: '整活删库跑路', name: '重庆警察学院' },
        { id: 'Team汪汪', name: '铁道警察学院' },
        { id: 'Z_L_L_麻辣香锅', name: '铁道警察学院' },
        { id: 'Givefree', name: '重庆警察学院' },
        { id: '彩虹七号', name: '铁道警察学院' },
        { id: 'And-one', name: '山西警察学院' },
        { id: '_W1nd3r_C_MRX_', name: '铁道警察学院' },
        { id: 'ttxiangshang', name: '铁道警察学院' },
        { id: 'Fly-shark', name: '新疆警察学院' },
        { id: 'miniminiminiL', name: '西安电子科技大学' },
        { id: 'miniL', name: '西安电子科技大学' },
        { id: '表面兄弟', name: '河南警察学院' },
        { id: '蓝帽线头头', name: '新疆警察学院' },
        { id: '我只会心疼哥哥', name: '河南警察学院' },
        { id: '水中捞月', name: '河南警察学院' },
        { id: '太师一枝花', name: '太原师范学院' },
        { id: '签到即巅峰', name: '河南警察学院' },
        { id: 'WT8', name: '甘肃政法大学' },
        { id: 'Nightmare', name: '湖北警官学院' }
      ],
      southList: [
        { id: '广外女生', name: '广东外语外贸大学' },
        { id: 'Kap0k_recrypt', name: '华南理工大学' },
        { id: 'DaiTeam', name: '华南理工大学' },
        { id: '逆浪而行', name: '福建警察学院' },
        { id: '云曦', name: '云南警官学院' },
        { id: 'Firebasky后援团1', name: '闽江学院,阜阳技师学院' },
        { id: 'Volcano', name: '广东工业大学' },
        { id: '菜得连签到不都会', name: '桂林电子科技大学' },
        { id: 'Ddmmhm', name: '云南警官学院' },
        { id: 'G2mtu', name: '广州航海学院' },
        { id: '领导喊打那就打', name: '广东省技师学院' },
        { id: '贵警重案组', name: '贵州警察学院' },
        { id: '山口组', name: '贵州警察学院' },
        { id: '我好饿我要姐姐抱着喂', name: '广州软件学院' },
        { id: '天汉安全团队', name: '广州航海学院,西华大学,新余学院' },
        { id: 'GUETSEC', name: '桂林电子科技大学' },
        { id: '打升堂鼓队', name: '福建警察学院' },
        { id: 'PH战队', name: '福建警察学院' },
        { id: '点击就送', name: '福建警察学院' },
        { id: 'HZ', name: '福建警察学院' },
        { id: 'xi40b3nd4n', name: '云南警官学院' },
        { id: '夺旗的鱼虾', name: '惠州学院' },
        { id: 'Error', name: '云南警官学院' },
        { id: '你们不要再打了', name: '南宁职业技术学院' },
        { id: 'NISA-你说对不对', name: '福建师范大学' },
        { id: 'G0DTeam', name: '福州大学至诚学院' },
        { id: 'TTL', name: '广东东软学院' },
        { id: 'G1D', name: '福州大学至诚学院' },
        { id: '贵州警院6队', name: '贵州警察学院' },
        { id: '11111', name: '惠州学院' },
        { id: 'y的三次方', name: '贵州警察学院' },
        { id: 'JTY', name: '贵州警察学院' },
        { id: 'Invictus', name: '贵州警察学院' },
        { id: 'YLZ', name: '广东东软学院' },
        { id: '送人头小队', name: '贵州警察学院' },
        { id: 'ZYY', name: '贵州警察学院' },
        { id: '五元分队', name: '广东东软学院' },
        { id: 'NoPwnNoFun', name: '广州大学' },
        { id: '华夏第一键队', name: '南宁职业技术学院' },
        { id: '经验兵战队', name: '福建警察学院' },
        { id: 'EMP', name: '福建警察学院' },
        { id: 'Echo2022', name: '福建警察学院' },
        { id: 'X10Sec3', name: '广东警官学院' },
        { id: 'X10Sec2', name: '广东警官学院' },
        { id: 'X10Sec1', name: '广东警官学院' }
      ],
      total: 50,
      currentPage1: 1,
      currentPage2: 1,
      currentPage3: 1,
      currentPage4: 1,
      pageSize: 10
    }
  },
  methods: {
    tabsClick (index) {
      this.active = index
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .q-table {
  & th {
    background-color: #243074;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 18px;
    height: 50px;
  }
  & tr {
    background-color: #02021C;
    height: 50px;
  }
}
/deep/ .q-table::before{
  background-color: #02021C;
}
/deep/ .q-table:hover{
  background-color: #02021C;
}
.q-table {
  border-bottom: 1px solid #465ECC;
}
/deep/ .q-pagination .q-pagination__button {
  border: 1px solid #465ECC;
  background-color: #141C4C;
}
.promotion-container {
  position: relative;
  margin: 0 auto;
  height: 689px;
  width: 1000px;
  color: white;
}
.tabs{
  width:100%;
  height: 100%;
  .tabs-title{
    ul {
      margin: 0;
      padding: 0;
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    li{
      cursor: pointer;
      height: 33px;
      line-height: 30px;
      width: 165px;
      list-style: none;
      float: left;
      text-align: center;
      box-sizing: border-box;
      font-size: 16px;
      font-family: FZLTZHK;
      font-weight: normal;
      color: #5891FA;
      &:hover {
        background: rgba(88, 145, 250, 0.1);
        border: 1px solid #5891FA;
        border-radius: 15px;
        color: #E4BA3D;
      }
    }
    .show-li {
      background: rgba(88, 145, 250, 0.1);
        border: 1px solid #5891FA;
        border-radius: 15px;
        color: #E4BA3D;
    }
  }
  .tabs-text {
    height: 100%;
    padding-top: 18px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 24px;
    .text{
      text-align: left;
      width:100%;
      display: none;
      .table-content {
        width: 1000px;
        height: 550px;
        border: 1px solid #465ECC;
      }
    }
    .q-pagination {
      display: flex;
      justify-content: center;
      margin-top: 30px;
    }
    .show {
      display: block;
    }
  }
}

</style>
